import { buildBoundLayoutRenderInput } from './buildBoundLayoutRenderInput';
import type { SubtitleLogoRenderConfig } from './buildSubtitleLogoRenderConfig';
import { buildLayersRenderInput } from '@/lib/layers/buildLayersRenderInput';
import type { MediaLayer } from '@/lib/layers/types';
import { DEFAULT_WATERMARK_POSITION, type WatermarkPosition } from '@/lib/watermark/watermarkPosition';

/** The `renderV2` input for one clip. Shared by single and mass export so the
 *  two cannot drift in what they send. */
export function buildClipRenderInput({
  format,
  subtitlesEnabled,
  renderExtras,
  brandKitId,
  layout,
  layers,
  layerClipDurationSec,
  watermarkPosition,
}: {
  format: 'vertical' | 'horizontal';
  subtitlesEnabled: boolean;
  renderExtras: SubtitleLogoRenderConfig;
  brandKitId: string | null | undefined;
  layout: Parameters<typeof buildBoundLayoutRenderInput>[0];
  layers: MediaLayer[];
  /** Layer windows are clamped to this (the clip's own duration). */
  layerClipDurationSec: number;
  /** Live (possibly unsaved) watermark position; null/absent = backend uses the saved one. */
  watermarkPosition?: WatermarkPosition | null;
}): Record<string, unknown> {
  const input: Record<string, unknown> = {
    aspect_ratio_format: format,
    subtitles_enabled: subtitlesEnabled,
    ...renderExtras,
  };
  if (brandKitId) input.brand_kit_id = brandKitId;
  Object.assign(input, buildBoundLayoutRenderInput(layout));
  const layerInput = buildLayersRenderInput(layers, layerClipDurationSec);
  if (layerInput.length > 0) input.layers = layerInput;
  if (watermarkPosition !== undefined) input.watermark_position = watermarkPosition ?? DEFAULT_WATERMARK_POSITION;
  return input;
}
